import { AxiosReportLas } from '../config';

const AvailabilityService = {
  generateExcel: ({
    empresa,
    dataInicial,
    dataFinal,
    unidades = [],
    grupoUnidades = [],
    subGrupoUnidades = [],
    gruposEquipamento = [],
    tiposEquipamento = [],
    equipamentos = [],
    sistemas = [],
    token,
  }) => {
    return AxiosReportLas({
      method: 'post',
      responseType: 'blob',
      headers: {
        'content-type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      url: `/v1/Relatorios/Disponibilidade`,
      data: {
        empresa,
        dataInicial,
        dataFinal,
        unidades,
        grupoUnidades,
        subGrupoUnidades,
        gruposEquipamento,
        tiposEquipamento,
        equipamentos,
        sistemas,
      },
    });
  },
};

export { AvailabilityService };
